import {
    IPersonProposalDemandListingModel,
    PersonSmartSearchParameterModel,
    PersonSmartSuggestionModel,
    IPersonPropertyParameterModel,
    IPersonPropertyListingModel,
    PersonProposalDemandParameterModel,
    IPersonProposalListingModel,
    PersonProposalParameterModel,
    IPersonListingModel,
    IPersonModel,
    MergePersonParams
} from "../models/person/index";
import axios, { AxiosPromise } from "axios";
import { GenericBaseParameter } from "../models/base-parameter";
import { GenericServices } from "./generic.services";
import { PersonEditModel } from "../models/person/person-edit.model";
import { personUri } from "../common";
import { ApiResponse } from "../models/app-configuration";
import { UserListingModel } from "../models/user";
import { CommonObjectModel } from "../models/common";
import { Listing } from "../models/listing-base-model";

export class PersonServices extends GenericServices {

    initPerson(): Promise<PersonEditModel> {
        return super.executeSelectingPost({}, personUri.changeInfoInit)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    delete response.data.Id;
                    response.data.DepartmentInfo = new CommonObjectModel;
                    response.data.ManagerInfo = new UserListingModel;
                    response.data.MaritalStatusInfo = new CommonObjectModel;
                    //response.data.MultList = [];
                    response.data.OriginContactInfo = new CommonObjectModel;
                    response.data.PreferredConfirmationInfo = new CommonObjectModel;
                    response.data.PreferredMediaInfo = new CommonObjectModel;
                    response.data.Relations = [];

                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getPersonDetailById(id: number, tabs?: string) {
        return super.executeSelectingNotEncode({ 
            tabs: tabs || '*'
         }, personUri.preview.replace(":id", id.toString()))
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                else return Promise.reject(response.message);
            })
            .catch(ex => { 
                return Promise.reject(ex);
            })
    }

    getPersonById(id: number, loadTabs: string, config?: any) {
        let path = personUri.paramId;
        if (loadTabs) {
            path += "?load-tab=" + loadTabs;
        }
        return super.executeSelectBy({ id }, path, config)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    }
    getCriterias<TResult>(params: PersonSmartSuggestionModel): AxiosPromise<TResult> {
        return this.executeSelectingPost<PersonSmartSuggestionModel, TResult>(params, personUri.smartSuggestion);
    }
    quickSearchPerson<TResult>(query: string): AxiosPromise<TResult> {
        let path = personUri.quickSearch + '/' + query;
        return this.executeSelecting<string, TResult>(null, path);
    }

    // @ts-ignore
    selectPost<TValue, TResult>(params: GenericBaseParameter<PersonSmartSearchParameterModel>): AxiosPromise<TResult> {
        console.log(22222,params)
        if (params != null)
            params.Fields = '*';
        return this.executeSelectingPost(params, personUri.search);
    }

    select<TValue, TResult>(params: TValue, path?: string): AxiosPromise<TResult> {
        return this.executeSelecting(params, path);
    }
    selectAsync<TValue, TResult>(params: TValue, path?: string): AxiosPromise<TResult[]> {
        return this.executeSelecting(params, path);
    }
    insertPerson<TResult>(model: PersonEditModel, force = false): AxiosPromise<TResult> {
      return this.executeCreating(model, personUri.default, force ? { params: { force: true } } : undefined).
        then((response: ApiResponse) => {
          return response.isSuccess
            ? Promise.resolve(response.data)
            : Promise.reject(response)
        })
        .catch(error => Promise.reject(error))
    }

    updatePerson<TResult>(originEntity: PersonEditModel, entity: PersonEditModel): AxiosPromise<TResult> {
        const clonedOriginEntity = JSON.parse(JSON.stringify(originEntity));
        const clonedEntity = JSON.parse(JSON.stringify(entity));

        let path = personUri.paramId.replace(':id', entity.Id.toString());
        return this.executeUpdatingCompare(clonedOriginEntity, clonedEntity, path)
          .then((response: ApiResponse) => {
            return response.isSuccess
              ? Promise.resolve(response.data)
              : Promise.reject(response)
          })
          .catch(error => Promise.reject(error))
    }
    selectBy<TValue, TResult>(value: TValue, path?: string): AxiosPromise<TResult> {
        return this.executeSelectBy(value, path);
    }
    deletePeople<TResult>(ids: number[]): AxiosPromise<TResult> {
        let path = personUri.paramId.replace(':id', ids.toString());
        return this.executeDeleting(path);
    }
    selectByAsync<TValue, TResult>(value: TValue, path?: string): AxiosPromise<TResult> {
        return this.executeSelectByAsync(value, path);
    }

    condition2Token<TResult>(entity: GenericBaseParameter<PersonSmartSearchParameterModel>, categoryType?: string): AxiosPromise<TResult> {
        return this.executeCreatingWithParam<GenericBaseParameter<PersonSmartSearchParameterModel>, any, any>(entity, { actionOn: categoryType || 'map' }, personUri.condition2Token);
    }
    token2Condition<TResult>(entity: GenericBaseParameter<PersonSmartSearchParameterModel>, categoryType?: string): AxiosPromise<TResult> {
        return this.executeCreatingWithParam<GenericBaseParameter<PersonSmartSearchParameterModel>, any, any>(entity, { actionOn: categoryType || 'map' }, personUri.token2Condition);
    }

    populateToken2Condition<TResult>(entity: GenericBaseParameter<PersonSmartSearchParameterModel>, categoryType?: string): AxiosPromise<TResult> {
        return this.executeCreatingWithParam<GenericBaseParameter<PersonSmartSearchParameterModel>, any, any>(entity, { actionOn: categoryType || 'map' }, personUri.token2Condition)
            .then((response: ApiResponse) => {
                return response.isSuccess ? Promise.resolve(response.data) : Promise.reject(response.message);
            }).catch((err => Promise.reject(err)));
    }
    /** PERSON DEMAND LIST  */
    // @ts-ignore
    getPersonDemands<TResult>(params: GenericBaseParameter<PersonProposalDemandParameterModel>): Promise<Listing<IPersonProposalDemandListingModel>> {
        let path = personUri.demand.replace(':id', (params.Condition.PersonId || 0).toString());
        return this.executeSelecting(params, path)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(new Listing<IPersonProposalDemandListingModel>('listOfDemands', response.data))
                    : Promise.reject(response.message)
            })
            .catch(error => Promise.reject(error))
    }

    /** PERSON PROPOSAL LIST  */
    // @ts-ignore
    getPersonProposals<TResult>(params: GenericBaseParameter<PersonProposalParameterModel>): Promise<IPersonProposalListingModel> {
        let path = personUri.proposal.replace(':id', (params.Condition.PersonId || 0).toString());
        return this.executeSelecting(params, path)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(new Listing<IPersonProposalListingModel>('listOfProposals', response.data))
                    : Promise.reject(response.message)
            })
            .catch(error => Promise.reject(error))
    }

    /** PERSON PROPERTY  */
    // @ts-ignore
    getPersonProperties<TResult>(params: GenericBaseParameter<IPersonPropertyParameterModel>): Promise<IPersonPropertyListingModel> {
        let path = personUri.property.replace(':id', (params.Condition.PersonId || 0).toString());
        return this.executeSelecting(params, path).then((response: ApiResponse) => {
            return response.isSuccess
                ? Promise.resolve(new Listing<IPersonPropertyListingModel>('listOfProperties', response.data))
                : Promise.reject(response.message)
        })
            .catch(error => Promise.reject(error))
    }

    getPersonHistories<TResult>(id: number, params: GenericBaseParameter<PersonSmartSearchParameterModel>): AxiosPromise<TResult> {
        let path = personUri.history.replace(':id', (id || 0).toString());
        delete params.Condition;

        return this.executeSelecting(params, path);
    }

    /** GET RELATIONS */
    getPersonRelations<TResult>(id: number, params: GenericBaseParameter<PersonSmartSearchParameterModel>): AxiosPromise<TResult> {
        let path = personUri.relationById.replace(':id', (id || 0).toString());
        return this.executeSelecting(undefined, path);
    }

    /** GET RELATIONS */
    getPersonConfiguration<TResult>(): AxiosPromise<TResult> {
        let path = personUri.configuration;
        return this.executeSelecting(undefined, path);
    }
    getListOfPeople(param: GenericBaseParameter<PersonSmartSearchParameterModel>, cancelTokenSource?: any) {
        return super.executeSelectingPost(param, personUri.search, cancelTokenSource)
            .then((response: ApiResponse) => {
                // executeSelectingPost resolves with axios errors instead of rejecting;
                // pass a superseded search on as a cancellation.
                if (axios.isCancel(response)) {
                    return Promise.reject(response);
                }
                if (response.isSuccess) {
                    return Promise.resolve(new Listing<IPersonListingModel>('listOfPeople', response.data));
                }
                else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    }

    getContentByTabName(person: IPersonModel, tabName: string, propertyName: string, extension: any = null) {
        if (propertyName === 'None') return Promise.resolve(person)
        if (person.Id > 0) {
            let url = personUri.loadContentByTabName;

            if (extension && extension.query) {
                url += extension.query;
            }

            return super.executeSelectBy({ id: person.Id, tab: tabName }, url)
                .then((response: ApiResponse) => {
                    return response.isSuccess
                        ? Promise.resolve(response.data)
                        : Promise.reject(response.message);
                })
                .catch(ex => {
                    console.log(ex)
                    return Promise.reject(ex)
                });
        } else {
            return Promise.resolve({ [propertyName]: [] })
        }
    }

    getQuickSearchPersons(ids: number[]) {
        if (ids.length <= 0)
            return Promise.reject('List of property ids must be more than 0');
        let url = personUri.getQuickSearchPersons.replace(':ids', ids.join(','))
        return super.executeSelectingNotEncode(undefined, url)
            .then((response: ApiResponse) => {
                return response.isSuccess ? Promise.resolve(response.data) : Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex)
                return Promise.reject(ex)
            });
    }

    mergePerson(params: MergePersonParams) {
        return this.executePost(params, personUri.mergePerson)
            .then((res: ApiResponse) => {
                console.log('res: ', res)
                return res.isSuccess ? Promise.resolve(res.data) : Promise.reject(res.message);
            }).catch(err => {
                console.log('err: ', err);
                return Promise.reject(err);
            })
    }

    createPersonRelation(params) {
        const uri = personUri.personRelation.replace(':id', params.PersonId)
        return this.executePost(params, uri)
            .then((res: ApiResponse) => {
                return res.isSuccess ? Promise.resolve(res.data) : Promise.reject(res.message);
            }).catch(err => {
                console.log('err: ', err);
                return Promise.reject(err);
            })
    }

    sendIdScannerRequest(id: number, payload: { Email?: string; PhoneNumber?: string; ExpiredIn?: number }) {
        if (!id) return Promise.reject('Invalid person id');
        const path = personUri.idScanner.replace(':id', id.toString());
        return super.executeCreating(payload, path)
            .then((response: ApiResponse) => {
                return response.isSuccess ? Promise.resolve(response.data) : Promise.reject(response.message);
            })
            .catch(error => Promise.reject(error));
    }

    deleteAll(payload) {
        return new Promise((resolve, reject) => {
            return super.executeDeletingWith(payload, personUri.deleteAll)
                .then((response: ApiResponse) => {
                    return response.isSuccess ? resolve(response.data) : reject(response.message);
                }).catch(error => {
                    return reject(error)
                })
        })
    }

    constructor() {
        super();
    }
}